export function bindKeyboardShortcuts(): void {
  document.addEventListener("keydown", (e) => {
    // Escape closes any open modal/dialog/drawer
    if (e.key === "Escape") {
      // Close confirm dialogs
      const confirmOverlay = document.querySelector(".confirm-dialog-overlay");
      if (confirmOverlay) {
        (confirmOverlay.querySelector(".confirm-dialog-cancel") as HTMLElement)?.click();
        return;
      }
      // Close modals
      const modal = document.querySelector(".modal:not(.hidden)");
      if (modal) {
        modal.classList.add("hidden");
        return;
      }
      // Close month drawer
      const drawer = document.querySelector(".month-drawer:not(.hidden)");
      if (drawer) {
        drawer.classList.add("hidden");
        return;
      }
      // Close search dropdown
      const searchDropdown = document.getElementById("search-results");
      if (searchDropdown && !searchDropdown.classList.contains("hidden")) {
        searchDropdown.classList.add("hidden");
        return;
      }
      // Close mobile sidebar
      const sidebar = document.querySelector(".sidebar.is-open");
      if (sidebar) {
        sidebar.classList.remove("is-open");
        document.querySelector(".sidebar-backdrop")?.remove();
      }
    }
  });
}
